module.exports = __webpack_public_path__ + "static/white_logo_transparent-3280689a77cd368e7286a6b010956b9f.png";